class CustomCarousel {

    constructor(element) {

        this.element = element;

        this.mode = element.dataset.mode || "hero";

        this.visible = Number(element.dataset.visible || 5);

        // Distance between tile centres
        this.spacing = Number(element.dataset.spacing || 260);

        this.scaleStep = Number(element.dataset.scale || 12) / 100;
        this.fadeStep = Number(element.dataset.fade || 25) / 100;

        this.slides = [...element.querySelectorAll(".custom-carousel__slide")];
        this.dots = [...element.querySelectorAll(".custom-carousel__dot")];

        this.prev = element.querySelector(".custom-carousel__arrow--prev");
        this.next = element.querySelector(".custom-carousel__arrow--next");

        this.current = 0;
        this.timer = null;

        /* -------------------------------------------------
           Lightbox items
        ------------------------------------------------- */

        this.lightboxItems = this.slides.map(slide => {

            const img = slide.querySelector("img");

            return {

                src: img.dataset.full || img.src,
                title: img.dataset.title || "",
                alt: img.alt || ""

            };

        });

        this.bindEvents();

        this.render();

        window.addEventListener("load", () => {

            this.render();

        });

        if (this.element.dataset.autoplay === "true") {

            this.startAutoplay();

        }

    }

    /* =====================================================
       Events
    ===================================================== */

    bindEvents() {

        this.prev?.addEventListener("click", () => {

            this.show(this.current - 1);

        });

        this.next?.addEventListener("click", () => {

            this.show(this.current + 1);

        });

        this.dots.forEach((dot, index) => {

            dot.addEventListener("click", () => {

                this.show(index);

            });

        });

        /* -----------------------------
           Lightbox
        ----------------------------- */

        this.slides.forEach((slide, index) => {

        slide.addEventListener("click", () => {
        
            if (this.mode !== "tiles")
                return;
        
            if (index !== this.current)
                return;
        
            window.CustomLightbox.open({
            
                items: this.lightboxItems,
                index
            
            });
        
        });

        });

        /* -----------------------------
           Resize
        ----------------------------- */

        let resizeTimer;

        window.addEventListener("resize", () => {

            clearTimeout(resizeTimer);

            resizeTimer = setTimeout(() => {

                if (this.mode === "tiles") {

                    this.renderTiles();

                }

            }, 50);

        });

    }

    /* =====================================================
       Public
    ===================================================== */

    show(index) {

        this.current =

            (index + this.slides.length) %

            this.slides.length;

        this.render();

    }

    render() {

        if (this.mode === "hero") {

            this.renderHero();

        }

        else {

            this.renderTiles();

        }

        this.updateDots();

    }

    /* =====================================================
       Hero
    ===================================================== */

    renderHero() {

        this.slides.forEach((slide, index) => {

            slide.removeAttribute("style");

            slide.classList.toggle(

                "is-active",

                index === this.current

            );

        });

    }

        /* =====================================================
       Tile Mode
    ===================================================== */

    renderTiles() {

        const maxOffset = Math.floor(this.visible / 2);

        this.slides.forEach((slide, index) => {

            let offset = index - this.current;

            /* Wrap */

            if (offset > this.slides.length / 2) {

                offset -= this.slides.length;

            }

            if (offset < -this.slides.length / 2) {

                offset += this.slides.length;

            }

            /* Hide outside visible range */

            if (Math.abs(offset) > maxOffset) {

                slide.style.opacity = "0";
                slide.style.pointerEvents = "none";
                slide.style.zIndex = "1";

                slide.style.transform =
                    "translate(-50%, -50%) scale(.85)";

                return;

            }

            const scale =
                1 - Math.abs(offset) * this.scaleStep;

            const opacity =
                1 - Math.abs(offset) * this.fadeStep;

            const x =
                offset * this.spacing;

            slide.style.opacity = opacity;

            slide.style.transform = `
                translate(
                    calc(-50% + ${x}px),
                    -50%
                )
                scale(${scale})
            `;

            slide.style.zIndex =
                Math.max(
                    0,
                    2 - Math.abs(offset)
                );

            slide.style.pointerEvents =
                offset === 0
                    ? "auto"
                    : "none";

            slide.classList.toggle(
                "is-active",
                offset === 0
            );

        });

    }

    /* =====================================================
       Dots
    ===================================================== */

    updateDots() {

        this.dots.forEach((dot, index) => {

            dot.classList.toggle(

                "is-active",

                index === this.current

            );

        });

    }

    /* =====================================================
       Autoplay
    ===================================================== */

    startAutoplay() {

        clearInterval(this.timer);

        const delay =
            Number(this.element.dataset.delay || 5) * 1000;

        this.timer = setInterval(() => {

            this.show(this.current + 1);

        }, delay);

        this.element.addEventListener("mouseenter", () => {

            clearInterval(this.timer);

        });

        this.element.addEventListener("mouseleave", () => {

            this.startAutoplay();

        });

    }

}

/* =========================================================
   Init
========================================================= */

function initCustomCarousel() {

    document
        .querySelectorAll(".custom-carousel")
        .forEach(carousel => {

            if (carousel.instance)
                return;

            carousel.instance =
                new CustomCarousel(carousel);

        });

}

document.addEventListener(
    "DOMContentLoaded",
    initCustomCarousel
);

document.addEventListener(
    "shopify:section:load",
    initCustomCarousel
);